<template>
  <base-material-card
    icon="mdi-clipboard-text-outline"
    color="primary"
    inline
    class="px-5 py-3 my-12"
  >
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("ticket.backbtn") }}</span>
    </v-tooltip>
    <template v-slot:after-heading>
      <div class="headline text-no-wrap font-weight-bold">
        {{ $t("ticket.createANewTicket") }}
      </div>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-dialog v-model="dialog" width="500" persistent>
        <v-card>
          <v-card-title class="white--text headline primary">
            Please select a label
          </v-card-title>

          <v-card-text class="my-2">
            <v-select
              v-model="ticket.label"
              :rules="[isRequired('Etiqueta')]"
              :items="[
                { name: $t('ticket.issues'), value: folders.issues },
                {
                  name: $t('ticket.mechanicalSupport'),
                  value: folders.hardware
                },
                { name: $t('ticket.suggestions'), value: folders.suggestions }
              ]"
              color="gray"
              item-text="name"
              item-value="value"
              :label="$t('ticket.label')"
          /></v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="$router.back()" color="orange">
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!ticket.label" color="primary" @click="setLabel">
              Confirm </v-btn
            ><v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row class="mx-auto" justify="space-around">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="ticket.title"
            color="gray"
            :rules="[isRequired('Titulo')]"
            :label="$t('ticket.subject')"
          />
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            v-model="ticket.equipment"
            :rules="[isRequired('Equipo Relacionado')]"
            :items="[$t('ticket.notAnEquipment')].concat(equipmentsList)"
            color="gray"
            item-text="equipTag"
            item-value="equipTag"
            :label="$t('ticket.relatedEquipment')"
          />
        </v-col>
        <v-col cols="12" md="12">
          <tiptap-vuetify
            :toolbar-attributes="{
              color: $vuetify.theme.isDark ? 'primary' : 'grey lighten-2'
            }"
            v-model="ticket.description"
            :extensions="
              $vuetify.breakpoint.mdAndUp ? extensions : extensionsMobile
            "
            :placeholder="$t('ticket.description')"
          />
          <!--    <v-textarea
            :rules="[isRequired('description')]"
            v-model="ticket.description"
            color="gray"
          /> -->
        </v-col>
      </v-row>

      <v-card-actions
        ><v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          width="200"
          x-large
          color="primary"
          @click="submit"
          >{{ $t("ticket.submit") }}</v-btn
        ><v-spacer></v-spacer> </v-card-actions></v-form
  ></base-material-card>
</template>

<script>
/* import { db } from "@/plugins/db"; */

import { sdIssuesWorkflow, foldersId } from "@/utils/wrikeHelper";
import { mapState, mapGetters } from "vuex";
import {
  TiptapVuetify,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  ListItem,
  OrderedList,
  Heading,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from "tiptap-vuetify";

export default {
  name: "new-ticket",
  components: { TiptapVuetify },
  data() {
    return {
      folders: foldersId,
      ticket: {
        title: "",
        description: "",
        equipment: ""
      },
      extensionsMobile: [
        Blockquote,
        Italic,
        Bold,
        ListItem,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3]
            }
          }
        ]
      ],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3]
            }
          }
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ],
      isRequired: name => v => !!v || `${name} es obligatorio.`,
      valid: true,
      tab: 0,
      status: [{ name: "Active" }, { name: "Inactive" }],
      tabs: ["Ticket details"],
      subject: "",
      content: "",
      dialog: false
    };
  },
  created() {
    this.dialog = true;
  },
  computed: {
    ...mapState("auth", ["user"]),

    ...mapGetters("equipments", ["equipmentsList"]),
    availableSteps() {
      const steps = [0];
      if (this.subject !== "" && this.content !== "") steps.push(1);
      return steps;
    },
    title() {
      return `[${this.ticket.equipment}] ${this.ticket.title}`;
    }
  },
  methods: {
    getLabel(label) {
      switch (label) {
        case 1:
          return this.$t("ticket.issues");
        case 2:
          return this.$t("ticket.mechanicalSupport");
        case 3:
          return this.$t("ticket.suggestions");
        default:
          return "Issues";
      }
    },
    next(valid) {
      if (!valid) return;
      this.submit();
    },
    setLabel() {
      const { user } = this.$store.state.auth;
      const project = this.$t("equipmentList.pilot");
      switch (this.ticket.label) {
        case foldersId.issues:
          this.ticket.description = `
          <h2>Environment</h2>
          <p><strong>User: ${user.firstName + " " + user.lastName}</strong></p>
          <p><strong>Device:</strong></p><p><strong>OS:</strong></p><p><strong>Browser:</strong></p><p><strong>Account/Project:${project}</strong></p><h3>Description</h3><p>Describe what's wrong.</p><h3>Steps to reproduce</h3><p>Example:</p><p>1. Go to settings &gt; Profile (this would take user to new screen)</p><p>2. Tap on More Options &gt; Delete Account</p><h3>Expected Result</h3><p>Results expected if there was no bug.</p><h3>Severity/Priority</h3><ul><li><p><em><strong>1. High/Critical</strong>: anything that impacts the normal user flow or blocks app usage</em></p></li><li><p><em><strong>2. Medium</strong>: anything that negatively affects the user experience</em></p></li><li><p><em><strong>3. Minor</strong>: ALL else (e.g., typos, missing icons, layout issues, etc.)&nbsp;</em></p></li></ul>
          `;
          this.dialog = false;
          return;
        case foldersId.hardware:
          this.ticket.description = `<h2>Environment</h2><p><strong>User: ${user.firstName +
            " " +
            user.lastName}</strong></p><p><strong>Account/Project:${project}</strong></p><h2>Background (What?)</h2><p><br></p><h3>Motives (Why?)</h3><ul><li><p><br></p></li></ul><h3>Requirements (How?)</h3><ul><li><p><br></p></li></ul><p><br></p>`;
          this.dialog = false;
          return;
        case foldersId.suggestions:
          this.ticket.description = `<h2>Environment</h2><p><strong>User: ${user.firstName +
            " " +
            user.lastName}</strong></p><p><strong>Account/Project:${project}</strong></p><h2>Background</h2><p><br></p><h3>User Story</h3><p><strong>As a</strong> ...</p><p><strong>I want to</strong> ...</p><p><strong>So that </strong>...</p><p><br></p><h3>Acceptance Criteria</h3><ul><li><p><br></p></li></ul>`;
          this.dialog = false;
          return;
        default:
          this.ticket.description = `<h2>Environment</h2><p><strong>User: ${user.firstName +
            " " +
            user.lastName}</strong></p><p><strong>Account/Project:${project}</strong></p><h2>Background (What?)</h2><p><br></p><h3>Motives (Why?)</h3><ul><li><p><br></p></li></ul><h3>Requirements (How?)</h3><ul><li><p><br></p></li></ul><p><br></p>`;
          this.dialog = false;
          return;
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const { description, label } = this.ticket;
        const { title } = this;
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });

        var myHeaders = new Headers();
        myHeaders.append(
          "Authorization",
          "Bearer eyJ0dCI6InAiLCJhbGciOiJIUzI1NiIsInR2IjoiMSJ9.eyJkIjoie1wiYVwiOjMyMTUxMTQsXCJpXCI6NzIzNTk2NyxcImNcIjo0NjIxNjE3LFwidVwiOjkwNjY3OTYsXCJyXCI6XCJVU1wiLFwic1wiOltcIldcIixcIkZcIixcIklcIixcIlVcIixcIktcIixcIkNcIixcIkRcIixcIk1cIixcIkFcIixcIkxcIixcIlBcIl0sXCJ6XCI6W10sXCJ0XCI6MH0iLCJpYXQiOjE2MDA3MjQwMzR9._9PYeO_CEByMZSmHCAdCzZaWCciAkOyCz_JPUbVqKrI"
        );

        var formdata = new FormData();
        formdata.append("title", title);
        formdata.append("description", description);
        formdata.append("customStatus", sdIssuesWorkflow.new);

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow"
        };

        try {
          await fetch(
            `https://www.wrike.com/api/v4/folders/${label}/tasks`,
            requestOptions
          );
          this.$dialog.notify.success(this.$t("ticket.messages.successful"), {
            position: "top-right",
            timeout: 5000
          });

          this.$refs.form.reset();
          loading.close();

          this.$router.push({ name: "Tickets" });
        } catch (error) {
          loading.close();
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      }
    }
  }
};
</script>

<style></style>
